import React from 'react';
export default function DisabledBillingTooltip() {
  return /*#__PURE__*/React.createElement("span", null, "Billing is disabled for maintenance, please try again later.", /*#__PURE__*/React.createElement("br", null), "For urgent matters please contact support.");
}